<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('attendanceEventsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="attendance-events-workspace">
      <app-master-table
        [title]="'attendanceEventsCatalog.title' | translate"
        [dataSource]="dataSource"
        [columnDefinitions]="columnDefinitions"
        [actions]="actions"
        [filters]="tableFilters"
        [isLoading]="isLoading"
        [enableRowClick]="false"
        [rowClickSelection]="true"
        [showContextMenu]="false"
        [useServerData]="true"
        [totalItems]="totalItems"
        [currentPage]="currentPage"
        [pageSize]="pageSize"
        [pageSizeOptions]="[15, 25, 50, 100, 200]"
        [tableMaxHeight]="'100%'"
        [exportFileName]="'attendance-events'"
        [searchValue]="searchValue"
        (add)="handleAdd()"
        (refresh)="loadData()"
        (details)="handleView($event)"
        (delete)="handleDelete($event)"
        (bulkDelete)="handleBulkDelete($event)"
        (searchChange)="onSearchChange($event)"
        (filtersChange)="onFiltersChange($event)"
        (filterSearchChange)="onFilterSearchChange($event)"
        (pageChange)="onPageChange($event)">
      </app-master-table>
    </div>
  </div>
</section>
